export const RESPONSE_CODES = {
  OK_NO_CONTENT: 204,
  NOT_FOUND: 404,
};
